module.exports = __webpack_public_path__ + "static/media/sc31.33.35.6f192b35.mp4";